import { useEffect } from "react";
import { BRAND } from "../lib/brandConfig";

// First-party booking URL (/book) → existing Calendly destination. Keeps email links on our domain.
export default function BookRedirect() {
  useEffect(() => { window.location.replace(BRAND.calendlyUrl); }, []);
  return (
    <main className="min-h-screen flex items-center justify-center bg-[#F7F5F0] px-6 text-center" data-testid="book-redirect">
      <div>
        <p className="text-[#1F2A44] font-semibold">Opening Bryan's calendar…</p>
        <a href={BRAND.calendlyUrl} className="text-sm text-[#C8A96B] underline" data-testid="book-redirect-link">
          Continue to booking if you are not redirected
        </a>
      </div>
    </main>
  );
}
